(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-capacity-body-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    const mount = () => {
      const root = document.querySelector('.ap-capacity-results .ymm-result-page');
      if (!root || root.dataset.apBodyLayout === 'ready') return;
      root.dataset.apBodyLayout = 'ready';
      const desktop = window.matchMedia('(min-width: 990px)');
      let selector;
      let queued = false;
      const arrange = () => {
        queued = false;
        selector = root.querySelector('#ymm_searchbox_cont') || selector;
        const filters = root.querySelector('.ymm_facet_filters');
        const grid = root.querySelector('.ymm-grid');
        if (!selector || !grid) return;
        if (desktop.matches && filters && selector.querySelectorAll('select.ymm-filter').length === 4) {
          if (selector.parentElement !== filters) filters.prepend(selector);
        } else if (selector.parentElement !== root) {
          root.insertBefore(selector, grid);
        }
      };
      const schedule = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(arrange);
      };
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      desktop.addEventListener('change', schedule);
      arrange();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }
    document.addEventListener('shopify:section:load', mount);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-capacity-gst"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const settings = document.getElementById('ap-capacity-gst');
    const root = document.getElementById('MainContent');
    if (!settings || !root || settings.dataset.apTitlesReady) return;
    settings.dataset.apTitlesReady = 'true';
    const cache = new Map();
    const states = new WeakMap();
    const pending = new WeakSet();
    const jobs = [];
    let active = 0;
    let scheduled = false;
    const cleanTitle = value => String(value || '').split(/\s*\|\s*/).filter(part => !/^Specification\s*:/i.test(part)).join(' | ').replace(/\s+/g, ' ').trim();
    const selection = () => {
      const url = new URL(window.location.href);
      if (/\/search\/?$/.test(url.pathname)) return '';
      const values = url.searchParams.getAll('rq');
      return values.length === 1 ? values[0] : '';
    };
    const productURL = link => {
      if (!link) return null;
      const url = new URL(link.href, window.location.origin);
      return url.origin === window.location.origin && /\/products\/[^/]+\/?$/.test(url.pathname) ? url : null;
    };
    const titleLink = card => card.querySelector('.grid-view-item__title a, .card-heading a.js-product-link');
    const applyQuality = (card, state) => {
      const title = card.querySelector('.grid-view-item__title');
      const url = productURL(titleLink(card));
      if (!title || !url || url.pathname !== state.path) return;
      const quality = String(state.quality || '').trim();
      let label = card.querySelector('[data-ap-card-quality]');
      if (!quality) {
        if (label) label.remove();
        return;
      }
      if (!label) {
        label = document.createElement('div');
        label.className = 'ap-card-quality card-eyebrow';
        label.dataset.apCardQuality = 'true';
      }
      if (label.nextElementSibling !== title) title.before(label);
      if (label.textContent !== quality) label.textContent = quality;
    };
    const applyTitle = (card, state) => {
      const link = titleLink(card);
      const url = productURL(link);
      if (!url || url.pathname !== state.path) return;
      const key = selection();
      const data = state.config;
      const valid = data && data.enabled && data.schema_version === 1 && String(data.product_id) === state.productId && Array.isArray(data.rows);
      const matches = valid && key ? data.rows.filter(row => row.selections && Object.prototype.hasOwnProperty.call(row.selections, key)) : [];
      const row = matches.length === 1 ? matches[0] : null;
      const title = cleanTitle(row ? row.description : state.defaultTitle);
      if (title && link.textContent.trim() !== title) link.textContent = title;
      card.dataset.apVehicleTitle = row ? 'matched' : (key ? 'unmatched' : 'default');
      card.querySelectorAll('a[href]').forEach(anchor => {
        const target = productURL(anchor);
        if (!target || target.pathname !== state.path) return;
        if (key) target.searchParams.set('rq', key);
        else target.searchParams.delete('rq');
        if (anchor.href !== target.href) anchor.href = target.href;
      });
    };
    const runJobs = () => {
      while (active < 4 && jobs.length) {
        active += 1;
        const job = jobs.shift();
        job().finally(() => { active -= 1; runJobs(); });
      }
    };
    const load = url => {
      if (!cache.has(url.pathname)) {
        const destination = new URL(url.href);
        destination.search = '';
        destination.searchParams.set('view', 'ap-gst-price');
        destination.searchParams.set('preview_theme_id', settings.dataset.themeId);
        cache.set(url.pathname, new Promise((resolve, reject) => {
          jobs.push(async () => {
            try {
              const response = await fetch(destination.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
              if (!response.ok) throw new Error('Card response unavailable');
              resolve(await response.text());
            } catch (error) { reject(error); }
          });
          runJobs();
        }));
      }
      return cache.get(url.pathname);
    };
    const update = () => {
      scheduled = false;
      root.querySelectorAll('product-card[data-ap-fitment-config]').forEach(card => {
        const link = titleLink(card);
        const url = productURL(link);
        if (!url) return;
        let state = states.get(card);
        if (!state || state.path !== url.pathname) {
          let config = null;
          try { config = JSON.parse(card.dataset.apFitmentConfig); } catch {}
          state = { path: url.pathname, config, productId: card.dataset.apProductId, defaultTitle: card.dataset.apDefaultTitle };
          states.set(card, state);
        }
        applyTitle(card, state);
      });
      root.querySelectorAll('.ap-capacity-results #products .ymm-grid-item').forEach(card => {
        const link = titleLink(card);
        const url = productURL(link);
        if (!url) return;
        let state = states.get(card);
        if (!state || state.path !== url.pathname) {
          state = { path: url.pathname, defaultTitle: link.textContent, config: null, productId: '', quality: '', loaded: false, failed: false };
          states.set(card, state);
        }
        applyTitle(card, state);
        applyQuality(card, state);
        const box = card.querySelector('.grid-view-item__meta');
        const needsPrice = settings.dataset.renderPrices === 'true' && box && !box.querySelector('[data-ap-gst-rendered]');
        if (pending.has(card) || state.failed || (state.loaded && !needsPrice)) return;
        pending.add(card);
        load(url).then(html => {
          if (!card.isConnected || states.get(card) !== state) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const payload = parsed.querySelector('[data-ap-card-fitment]');
          if (payload && payload.dataset.apHandle === url.pathname.split('/').filter(Boolean).pop()) {
            state.productId = payload.dataset.apProductId;
            state.defaultTitle = payload.dataset.apDefaultTitle;
            state.quality = payload.dataset.apQuality || '';
            try { state.config = JSON.parse(payload.dataset.apFitmentConfig); } catch {}
          }
          state.loaded = true;
          applyTitle(card, state);
          applyQuality(card, state);
          const price = parsed.querySelector('.price');
          if (needsPrice && price && box.isConnected) {
            price.dataset.apGstRendered = 'true';
            box.replaceChildren(price);
          }
          if (needsPrice && !price) state.failed = true;
        }).catch(() => { state.failed = true; }).finally(() => { pending.delete(card); schedule(); });
      });
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-capacity-results-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('#ymm_search, #ymm_reset');
    if (!button || button.disabled) return;
    const form = button.closest('#ymm_form');
    const config = document.getElementById('ap-capacity-navigation');
    if (!form || !config || !config.dataset.resultUrl) return;
    if (button.id === 'ymm_reset') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const destination = new URL(config.dataset.resultUrl, window.location.origin);
      const current = new URL(window.location.href);
      ['preview_theme_id', '_ab', '_fd', '_sc'].forEach((key) => {
        if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
      });
      window.location.replace(destination.href);
      return;
    }
    const values = Array.from(form.querySelectorAll('select.ymm-filter'), (field) => field.value);
    const prefixes = ['mk_', 'md_', 'yr_', 'gh_'];
    if (values.length !== 4 || values.some((value, index) => !value.startsWith(prefixes[index]) || value.length <= prefixes[index].length)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const destination = new URL(config.dataset.resultUrl, window.location.origin);
    destination.searchParams.set('rq', values.join('__'));
    window.location.assign(destination.href);
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-category-sidebar"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.apCategoryCardsReady) return;
  window.apCategoryCardsReady = true;
  const order = ['body', 'cooling', 'electrical', 'mechanical', 'steering & suspension'];
  const normalise = (value) => value.replace(/\s*&\s*/g, ' & ').replace(/\s+/g, ' ').trim().toLowerCase();
  const desktop = window.matchMedia('(min-width: 990px)');
  const capacityState = new Map();
  let scheduled = false;
  let panelNumber = 0;
  const nativeHeading = (group) => group.querySelector('.facet-toggle > span:first-child');
  const addChevron = (heading) => {
    const iconUrl = document.getElementById('ap-category-sidebar-config')?.dataset.iconUrl;
    if (!heading || !iconUrl || heading.querySelector('.ap-category-chevron')) return;
    const icon = document.createElement('img');
    icon.className = 'ap-category-chevron';
    icon.src = iconUrl;
    icon.alt = '';
    icon.width = 18;
    icon.height = 18;
    heading.append(icon);
  };
  const sortGroups = (groups) => {
    const parents = new Set(groups.map((group) => group.parentElement));
    parents.forEach((parent) => {
      if (!parent) return;
      const children = Array.from(parent.children);
      const members = children.filter((child) => groups.includes(child));
      const sorted = [...members].sort((a, b) => order.indexOf(a.dataset.apCategory) - order.indexOf(b.dataset.apCategory));
      let index = 0;
      const wanted = children.map((child) => members.includes(child) ? sorted[index++] : child);
      wanted.forEach((child, position) => {
        if (parent.children[position] !== child) parent.insertBefore(child, parent.children[position] || null);
      });
    });
  };
  const capacityGroup = (heading, root) => {
    let group = heading.parentElement;
    while (group && group !== root) {
      if (group.matches('.ymm_facet_filters, #ymm_left_filtrs, .ymm_facet_cont')) return null;
      const labels = group.querySelectorAll('.ymm_filter_lbl_cont');
      if (labels.length !== 1) return null;
      if (group.querySelector('.ymm_facet_filter_display')) return group;
      group = group.parentElement;
    }
    return null;
  };
  const setCapacityOpen = (group, open) => {
    const heading = group.querySelector('.ymm_filter_lbl_cont');
    const panel = group.querySelector('.ymm_facet_filter_display');
    if (!heading || !panel) return;
    group.dataset.apOpen = String(open);
    heading.setAttribute('aria-expanded', String(open));
    capacityState.set(group.dataset.apCategory, open);
  };
  const textMeasure = document.createElement('canvas').getContext('2d');
  const correctFilterText = () => {
    document.querySelectorAll('.page-layout-sidebar, .collection-actions-filters, .ap-capacity-results .ymm_facet_filters').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script, style, textarea, select, option')) continue;
        const corrected = node.nodeValue.replace(/&(?:amp;)+/g, '&');
        if (corrected !== node.nodeValue) node.nodeValue = corrected;
      }
    });
  };
  const showFullVariant = () => {
    document.querySelectorAll('#ymm_searchbox').forEach((root) => {
      const selects = root.querySelectorAll('select');
      if (selects.length !== 4) return;
      const select = selects[3];
      if (!select.clientWidth || !textMeasure) return;
      const text = select.selectedOptions[0]?.textContent.trim() || '';
      const style = getComputedStyle(select);
      textMeasure.font = style.font || `${style.fontSize} ${style.fontFamily}`;
      const available = select.clientWidth - parseFloat(style.paddingLeft) - Math.max(32, parseFloat(style.paddingRight));
      const clipped = Boolean(select.value && textMeasure.measureText(text).width > available);
      let note = select.parentElement.querySelector('.ap-variant-full-value');
      if (!note && clipped) {
        note = document.createElement('span');
        note.className = 'ap-variant-full-value';
        note.setAttribute('aria-live', 'polite');
        select.insertAdjacentElement('afterend', note);
      }
      if (note) {
        if (note.textContent !== text) note.textContent = text;
        note.hidden = !clipped;
      }
      if (select.title !== text) select.title = text;
    });
  };
  const enhance = () => {
    scheduled = false;
    correctFilterText();
    showFullVariant();
    document.querySelectorAll('.page-layout-sidebar-inner-content').forEach((container) => {
      const groups = [];
      container.querySelectorAll(':scope > .js-filter').forEach((group) => {
        const heading = nativeHeading(group);
        const key = normalise(heading?.textContent || '');
        if (!order.includes(key)) return;
        group.classList.add('ap-category-group');
        group.dataset.apCategory = key;
        addChevron(group.querySelector('.facet-toggle'));
        groups.push(group);
      });
      sortGroups(groups);
    });
    document.querySelectorAll('.ap-capacity-results .ymm_facet_filters').forEach((root) => {
      const groups = [];
      root.querySelectorAll('.ymm_filter_lbl_cont').forEach((heading) => {
        const key = normalise(heading.textContent || '');
        if (!order.includes(key)) return;
        const group = capacityGroup(heading, root);
        if (!group) return;
        const panel = group.querySelector('.ymm_facet_filter_display');
        group.classList.add('ap-category-group');
        group.dataset.apCategory = key;
        groups.push(group);
        if (!desktop.matches) {
          if (heading.dataset.apKeyboard === 'true') {
            if (heading.dataset.apPreviousRole) heading.setAttribute('role', heading.dataset.apPreviousRole);
            else heading.removeAttribute('role');
            if (heading.dataset.apPreviousTabindex) heading.setAttribute('tabindex', heading.dataset.apPreviousTabindex);
            else heading.removeAttribute('tabindex');
            heading.removeAttribute('aria-controls');
            heading.removeAttribute('aria-expanded');
            delete heading.dataset.apKeyboard;
          }
          return;
        }
        if (heading.dataset.apKeyboard !== 'true') {
          heading.dataset.apPreviousRole = heading.getAttribute('role') || '';
          heading.dataset.apPreviousTabindex = heading.getAttribute('tabindex') || '';
          heading.dataset.apKeyboard = 'true';
        }
        if (!panel.id) panel.id = `ap-category-panel-${++panelNumber}`;
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-controls', panel.id);
        addChevron(heading);
        const selected = Boolean(panel.querySelector('input:checked'));
        const open = capacityState.has(key) ? capacityState.get(key) : key === 'body' || selected;
        setCapacityOpen(group, open);
      });
      sortGroups(groups);
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };
  const toggle = (event) => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const heading = event.target.closest('.ap-capacity-results .ap-category-group .ymm_filter_lbl_cont');
    if (!heading || heading.dataset.apKeyboard !== 'true') return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const group = heading.closest('.ap-category-group');
    setCapacityOpen(group, group.dataset.apOpen !== 'true');
  };
  const start = () => {
    const root = document.getElementById('MainContent');
    if (!root) return;
    new MutationObserver(schedule).observe(root, {childList: true, subtree: true, characterData: true});
    document.addEventListener('change', schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('click', toggle, true);
    document.addEventListener('keydown', toggle, true);
    document.addEventListener('shopify:section:load', schedule);
    desktop.addEventListener('change', schedule);
    enhance();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-fitment-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-fitment-description')) {
    customElements.define('ap-fitment-description', class extends HTMLElement {
      connectedCallback() {
        try {
          this.config = JSON.parse(this.dataset.config);
          if (String(this.config.product_id) !== this.dataset.productId || this.config.schema_version !== 1 || !Array.isArray(this.config.rows)) return;
          const list = this.querySelector('[data-fitment-list]');
          list.replaceChildren();
          for (const row of this.config.rows) {
            const item = document.createElement('li');
            item.textContent = row.vehicle_label;
            list.append(item);
          }
          this.querySelector('[data-all-fitments]').hidden = this.config.rows.length === 0;
          this.updateDescription = this.renderDescription.bind(this);
          window.addEventListener('popstate', this.updateDescription);
          window.addEventListener('pageshow', this.updateDescription);
          this.renderDescription();
        } catch {
          this.dataset.matchState = 'unavailable';
        }
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.updateDescription);
        window.removeEventListener('pageshow', this.updateDescription);
      }
      renderDescription() {
        const selections = new URL(window.location.href).searchParams.getAll('rq');
        const key = selections.length === 1 ? selections[0] : '';
        const matches = key ? this.config.rows.filter(row => Object.prototype.hasOwnProperty.call(row.selections, key)) : [];
        const row = matches.length === 1 ? matches[0] : null;
        const status = this.querySelector('[data-status]');
        const selected = this.querySelector('[data-selected]');
        const general = this.querySelector('[data-general]');
        const vehicle = this.querySelector('[data-vehicle]');
        const description = this.querySelector('[data-specific-description]');
        selected.hidden = !row;
        general.hidden = Boolean(row);
        status.hidden = Boolean(row);
        vehicle.textContent = '';
        description.textContent = '';
        this.dataset.matchState = row ? 'matched' : (selections.length ? 'unmatched' : 'unselected');
        this.dataset.sourceId = row ? row.source_id : '';
        const scope = this.closest('[id^="shopify-section-"]');
        const heading = scope && scope.querySelector('[data-ap-fitment-title]');
        const summary = scope && scope.querySelector('[data-ap-vehicle-summary]');
        const cleanTitle = value => String(value || '').split(/\s*\|\s*/).filter(part => !/^Specification\s*:/i.test(part)).join(' | ').replace(/\s+/g, ' ').trim();
        if (heading) heading.textContent = cleanTitle(row ? row.description : this.config.base_description);
        if (summary) {
          summary.hidden = !row;
          summary.textContent = row ? [row.make, row.model, row.selections[key], row.variant].join(' · ') : '';
        }
        const enquiry = scope && scope.querySelector('[data-ap-enquiry]');
        const emailLink = enquiry && enquiry.querySelector('[data-ap-email-enquiry]');
        if (emailLink) {
          const vehicleText = row ? [row.make, row.model, row.selections[key], row.variant].join(' · ') : '';
          const body = enquiry.dataset.body + (vehicleText ? '\n\n' + enquiry.dataset.vehicleLabel + ': ' + vehicleText : '');
          emailLink.href = 'mailto:' + enquiry.dataset.email + '?subject=' + encodeURIComponent(enquiry.dataset.subject) + '&body=' + encodeURIComponent(body);
        }
        if (row) {
          vehicle.textContent = [row.make, row.model, row.selections[key], row.variant].join(' · ');
          description.textContent = row.description;
        } else {
          status.textContent = selections.length ? this.dataset.invalidSelection : this.dataset.noSelection;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-product-enquiry-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-product-enquiry')) {
    customElements.define('ap-product-enquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-enquiry-open]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
        this.querySelector('[data-enquiry-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.trigger.focus());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.querySelector('form')?.addEventListener('submit', () => this.syncProduct());
        if (this.querySelector('[data-enquiry-response]')) this.open();
      }
      syncProduct() {
        const scope = this.closest('[id^="shopify-section-"]');
        const title = scope?.querySelector('[data-ap-fitment-title]')?.textContent.trim() || this.dataset.productTitle;
        const vehicleElement = scope?.querySelector('[data-ap-vehicle-summary]');
        const vehicle = vehicleElement && !vehicleElement.hidden ? vehicleElement.textContent.trim() : '';
        this.querySelector('[data-enquiry-product]').textContent = title;
        this.querySelector('[data-enquiry-vehicle]').textContent = vehicle;
        this.querySelector('[data-enquiry-vehicle-row]').hidden = !vehicle;
        const productInput = this.querySelector('[data-enquiry-product-input]');
        const urlInput = this.querySelector('[data-enquiry-url-input]');
        const vehicleInput = this.querySelector('[data-enquiry-vehicle-input]');
        if (productInput) productInput.value = title;
        if (vehicleInput) { vehicleInput.value = vehicle; vehicleInput.disabled = !vehicle; }
        if (urlInput) {
          const productUrl = new URL(this.dataset.productUrl, window.location.origin);
          const selections = new URL(window.location.href).searchParams.getAll('rq');
          if (vehicle && selections.length === 1) productUrl.searchParams.set('rq', selections[0]);
          urlInput.value = productUrl.href;
        }
      }
      open() {
        this.syncProduct();
        if (!this.dialog.open) this.dialog.showModal();
        const focusTarget = this.querySelector('[data-enquiry-response]') || this.querySelector('input[name="contact[name]"]');
        focusTarget?.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
